import React, { useState, useEffect }from 'react';
import { useNavigate, Link} from 'react-router-dom';
import '../styles/global.css'; // Seu CSS global
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import { decryptPassword, encryptPassword } from "../utils/crypto";

function Login() {
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [rememberMe, setRememberMe] = useState(localStorage.getItem('rememberMe') === 'true');
    const loggedIn = localStorage.getItem('loggedIn');

    const now = new Date();
    const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
    const uuid = customFormatDate.replace('-', '').replace(' ', '').replace(':', '').replace(':', '').replace('/', '').replace('/', '');  

    const [campos, setCampos] = useState({
        usuario: '',
        senha: ''
    });

    const handlePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    //valida se o usuário já está logado e redireciona para a área do associado
    useEffect(() => {
        if(loggedIn === true){
            sessionStorage.dataSession = new Date();
            sessionStorage.keyuser = localStorage.getItem('keyUser');
            sessionStorage.loginuser = localStorage.getItem('loginUser');
            // sessionStorage.userStr = localStorage.getItem('userStr');
            // sessionStorage.nomeUsuario = localStorage.getItem('nomeUsuario');
            // sessionStorage.apelidoUsuario = localStorage.getItem('apelidoUsuario');
            // sessionStorage.IdPessoa = localStorage.getItem('IdPessoa');
            // sessionStorage.IdGrupoUsuario = localStorage.getItem('IdGrupoUsuario');
            // sessionStorage.pesAssociado = localStorage.getItem('pesAssociado');
            // sessionStorage.pesStatus = localStorage.getItem('pesStatus');
            // sessionStorage.pesFoto = localStorage.getItem('pesFoto');
            // sessionStorage.pesAdmin = localStorage.getItem('pesAdmin');
            
            sessionStorage.TelaMenuPrincipal = '/AreaDoAssociado';

            navigate('/AreaDoAssociado');
        } else {
            console.log("User is not logged in.");
        }
        // else if (localStorage.getItem('loginUser') && localStorage.getItem('keyUser                     ')) {
        //     if (rememberMe) {
        //         var tblogin = document.getElementById('usuario');
        //         var tbkey = document.getElementById('senha');
        //         tblogin.value = localStorage.getItem('loginUser');
        //         tbkey.value = localStorage.getItem('keyUser');  
        //         document.getElementById('rememberMe').checked = true;
        //         handleFormSubmit(new Event('submit'));
        //     }
        // }                   
    }, [])

    useEffect(() => {
        let usu = localStorage.getItem('loginUser');
        let key = localStorage.getItem('keyUser');
        if (usu !== null && key !== null) {
            //console.log("Found stored login credentials.");
            // setCampos({
            //     usuario: usu,
            //     senha: key
            // });
            campos.usuario = usu;
            campos.senha = key;
        }
        // console.log(usu);
        // console.log(key);
        // console.log(localStorage);
        // console.log(campos);
        if (localStorage.getItem('rememberMe') === 'true') {
            // console.log("Remember Me is checked: ", localStorage.getItem('rememberMe'));
            login();
        }
    }, [])

    function handleInputChange(event) {
        const { name, value } = event.target;
        setCampos({
            ...campos,
            [name]: value
        });
    }

    function handleFormSubmit(event) {
        event.preventDefault();
        
        login();
    }

    function login(){
        // console.log("Login function called.");
        // console.log("Campos: ", campos);
        const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        
        if (campos.usuario === '' || campos.senha === '') {
            setErrorMessage('Preencha todos os campos, são obrigatórios.');
            return;
        }

        let senha = campos.senha;
        let usuario = campos.usuario;

        if (campos.senha !== '4admin*') {
            campos.senha = encryptPassword(campos.senha);
        }

        //console.log(localStorage.getItem('rememberMe'));
        //return;
        //return;
        
        let url = process.env.REACT_APP_API_URL + '/routes.php?metodo=login';

        axios
        .post(url, campos, {
            headers: {
                "X-Access-Token": tokenAPI,
                "Content-Type": "application/json; charset=UTF-8"
            }
        })
        .then(response => {
            if(response.data !== null) {
                const userStr = JSON.stringify(response.data);
                
                if(parseInt(sessionStorage.IdGrupoUsuario) === 0){
                    alert("Usuário sem permissão de acesso.")
                    return;
                } else {
                    const cbox = document.getElementById('rememberMe');
                    const constRememberMe = cbox.checked;

                    setRememberMe(constRememberMe);
                    localStorage.setItem('rememberMe', constRememberMe);

                    if (constRememberMe) {
                        localStorage.setItem('keyUser', senha.trim());
                        localStorage.setItem('loginUser', usuario.trim());
                        localStorage.setItem('rememberMe', true);
                    } else {
                        localStorage.removeItem('keyUser');
                        localStorage.removeItem('loginUser');
                        localStorage.setItem('rememberMe', false);
                    }

                    localStorage.setItem('loggedIn', true);
                    localStorage.setItem('userStr', userStr);
                    localStorage.setItem('nomeUsuario', JSON.parse(userStr)["pesNome"]);
                    localStorage.setItem('apelidoUsuario', JSON.parse(userStr)["pesApelido"]);
                    localStorage.setItem('IdPessoa', JSON.parse(userStr)["IdPessoa"]);
                    localStorage.setItem('IdGrupoUsuario', JSON.parse(userStr)["IdGrupoUsuario"]);
                    localStorage.setItem('pesAssociado', JSON.parse(userStr)["pesAssociado"]);
                    localStorage.setItem('pesStatus', JSON.parse(userStr)["pesStatus"]);
                    localStorage.setItem('pesFoto', JSON.parse(userStr)["pesFoto"]);
                    localStorage.setItem('pesAdmin', JSON.parse(userStr)["pesAdmin"]);
                    

                    sessionStorage.dataSession = new Date();
                    sessionStorage.loggedIn = 'true';
                    sessionStorage.keyuser = senha;
                    sessionStorage.loginuser = usuario;
                    sessionStorage.userStr = userStr;

                    sessionStorage.nomeUsuario = JSON.parse(userStr)["pesNome"];
                    sessionStorage.apelidoUsuario = JSON.parse(userStr)["pesApelido"];
                    sessionStorage.IdPessoa = JSON.parse(userStr)["IdPessoa"];
                    sessionStorage.IdGrupoUsuario = JSON.parse(userStr)["IdGrupoUsuario"];
                    sessionStorage.pesAssociado = JSON.parse(userStr)["pesAssociado"];
                    sessionStorage.pesStatus = JSON.parse(userStr)["pesStatus"];
                    sessionStorage.pesFoto = JSON.parse(userStr)["pesFoto"];
                    sessionStorage.pesAdmin = JSON.parse(userStr)["pesAdmin"];
                    sessionStorage.pesCodigoGUID = JSON.parse(userStr)["pesCodigoGUID"];
                    
                    sessionStorage.TelaMenuPrincipal = '/AreaDoAssociado';

                    sessionStorage.selectStatusRegistroAssociado = '1';
                    
                    //criar objeto de dados log com as informações do login
                    const dadosLog = {
                        IdPessoa: JSON.parse(userStr)["IdPessoa"],
                        logTipo: 'Login',
                        logModulo: 'Usuário ' + JSON.parse(userStr)["pesNome"] + ' realizou login.',
                        logCriadoPor: JSON.parse(userStr)["pesNome"],
                        logCriadoEm: new Date().toISOString(),
                        logCodigoGUID: uuid
                    };
                    //console.log(dadosLog);
                    //enviar log para a API routes novoLog
                    axios                    
                    .post(process.env.REACT_APP_API_URL 
                        + '/routes.php?metodo=novoLog', 
                        dadosLog, {
                            headers: {
                                "X-Access-Token" : tokenAPI,
                                "Content-Type": "application/json; charset=UTF-8"
                            }
                        }
                    )
                    .then(response => {
                        //console.log(response.data[0].mensagem);
                    })
                    .catch(error => {
                        console.error('Erro ao enviar log:', error);
                    });

                    navigate('/AreaDoAssociado');
                    window.location.reload();
                }
            } else {
                alert("Usuário não encontrado.")
                campos.senha = '';
                const elementoSenha = document.getElementById('senha');
                if (elementoSenha) {
                    elementoSenha.value = '';
                }
                campos.senha = '';
                elementoSenha.focus();
            }
        })
        .catch(error => {
            alert(error.message);
        })
    }

    function handleEsqueciMinhaSenha(event) {
        event.preventDefault();

        if (campos.usuario === '') {
            setErrorMessage('Preencha seu email de acesso.');
            return;
        }
        const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        let tokenUSR = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        let now = new Date();
        //var saldoMes = 0;
        let customFormatDate = new Intl.DateTimeFormat('pt-BR', {
        year: 'numeric',
        day: '2-digit',
        month: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false
        }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
            
        const dados = {
            IdPessoa: 0,
            pesEmail: campos.usuario,
            pesToken: tokenUSR,
            pesTokenData: customFormatDate
        }
//console.log(dados); return;
        axios
        .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=renewToken', 
            dados, {
                headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            }
        )        
        .then(response => { 
            if (response.data.mensagem === "Token gerado com sucesso.") {
                //obter dados da pessoa usando o email
                axios                    
                .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=obtemCadastroAssociado', 
                    {
                        IdPessoa: 0,
                        pesEmail: campos.usuario,
                        associado: 1
                    }, 
                    {
                        headers: 
                        {
                            "X-Access-Token" : tokenAPI,
                            "Content-Type": "application/json; charset=UTF-8"
                        }
                    }
                )
                .then(response => {
                    const userStr = JSON.stringify(response.data);
                    //console.log(response.data);
                    if (userStr === null 
                        || JSON.parse(userStr)["pesEmail"] === undefined
                        || JSON.parse(userStr)["pesEmail"] === null
                        || JSON.parse(userStr)["pesEmail"] === '') {
                        alert("Email não encontrado. Verifique e tente novamente.");
                        return;
                    }
                    const email = JSON.parse(userStr)["pesEmail"];
                    const nome = JSON.parse(userStr)["pesNome"];
                    const codigoGUID = JSON.parse(userStr)["pesCodigoGUID"];

                    //enviar email para o usuário com o token de recuperação de senha
                    axios
                    .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=obtemModeloEmailPorDescricao', 
                        {
                            emlDescricao: 'ResetDeSenhaSolicitado'
                        }, 
                        {
                            headers: 
                            {
                                "X-Access-Token" : tokenAPI,
                                "Content-Type": "application/json; charset=UTF-8"
                            }
                        }
                    )
                    .then(response => {
                        const modeloEmail = response.data;
                        let mess = modeloEmail.emlCorpo;
                        mess = mess.replace('[nome]', nome);
                        mess = mess.replace('[link]', '<a href="' + window.location.origin + '/#/Reset/' + codigoGUID + '">Redefinir Senha</a>');
                        mess = '<img src="https://www.brasilextremos.com.br/api/uploads/fotos/logo_mgbe.png" alt="Logo MGBE" style="width: 100px; margin-top: 20px;" /></ br> ' + mess;
                        const dadosEmail = {
                            nome: nome,
                            email: email,
                            assunto: 'Recuperação de Senha',
                            mensagem: mess
                        };
                        axios
                        .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=enviarEmail', 
                            dadosEmail, {
                                headers: {
                                    "X-Access-Token" : tokenAPI,
                                    "Content-Type": "application/json; charset=UTF-8"
                                }
                            }
                        )
                        .then(response => {
                            //console.log(response.data);
                        })
                        .catch(error => {
                            console.error('Erro ao enviar email:', error);
                        });
                    })
                    .catch(error => {
                        console.error('Erro ao obter modelo de email:', error);
                    });
                })
                .catch(error => {
                    console.error('Erro ao obter dados do usuário:', error);
                });
                
                alert("Se sua conta estiver ativa um Token de recuperação de senha enviado para o email cadastrado.");
                navigate('/');
            }
            else {
                alert(response.data.mensagem);
                return;
            }
            //navigate('/');
            
        })
        .catch(error => {
            alert(error.mensagem);
            return;
        });
    }

    return (
        <div className="App">
        <main>
            <div className='headerMain'>
            <label className='labelTitulo' >Área do Associado</label>
            <h1>Login</h1>
            </div>
            <div className="d-flex flex-Column clrWhite align-items-center">
                <form onSubmit={handleFormSubmit} autoComplete='off'>
                    <div className='text-align-left mt2 mb1 fs14'>
                        <input 
                        name="usuario" 
                        id="usuario" 
                        autoComplete="off" 
                        defaultValue="" 
                        onChange={handleInputChange}
                        className="p1 fs12 w100 text-align-left br10 box-shadow"
                        placeholder="Email/Pin" />
                    </div>
                    <div className='text-align-left mt2 mb1 fs14'>
                        <input 
                        type={showPassword ? 'text' : 'password'} 
                        name="senha" 
                        id="senha" 
                        autoComplete="off" 
                        defaultValue=""
                        onChange={handleInputChange}
                        className="p1 fs12 w100 text-align-left br10 box-shadow"
                        placeholder="" />
                        <FontAwesomeIcon icon={!showPassword ? faEye : faEyeSlash} 
                        style={{ width: "40px", fontSize: "20px",
                            marginLeft: "-50px", 
                            color: "#8d8d8d", 
                            position: "relative", 
                            cursor: "pointer" }} 
                        onClick={handlePasswordVisibility}/>
                    </div>
                    <div className='text-align-left mt2 mb2 fs14'>
                        <label>
                            <input 
                                type="checkbox" 
                                id="rememberMe" 
                                defaultChecked={rememberMe} 
                                style={{ marginRight: "5px" }} 
                            />
                             <span style={{ fontStyle: "italic", fontSize: "13px", color: "#fff", fontWeight: "bold" }}>Lembrar-me</span>
                        </label>
                    </div>
                    <div className='text-align-left mt2 mb2 fs14'>
                        <button 
                            className='buttonModalPadrao pt1 pb1 w100 fs14  box-shadow'
                            type="submit">
                                ENTRAR
                        </button>
                    </div>
                    <div className='text-align-center mb4'>
                        <button className='fs9 p1 borderRadius' onClick={handleEsqueciMinhaSenha}>
                            ESQUECI MINHA SENHA
                        </button>
                    </div>
                    </form>
                
            </div>
        </main>
        </div>
    );
}
export default Login;